export const pluralize = (one: string, two: string, five: string, num: number): string => {
  if (num > 5 && num < 20) return five;
  if (num % 10 === 1 ) return one;
  if (num % 10 < 5 && num > 0 ) return two;

  return five;
}
